
import { TermsPageProps } from './TermsPage.types';
import { EditorialContent } from '@otomoro/components/shared/EditorialContent';
import { LegalHeader } from '@otomoro/components/legal/LegalHeader';
import { PageWrapper } from "@otomoro/components/layout/PageWrapper";

export default function TermsPage({ data }: TermsPageProps) {
  if (!data) {
    return (
      <div className="text-center">
        Please start editing your Terms document to see the preview!
      </div>
    )
  }

  return (
    <PageWrapper>
      <LegalHeader title={data.pageTitle} updatedAt={data._updatedAt}/>

      {data.content && (
        <EditorialContent blocks={data.content} hasMb={true} />
      )}
    </PageWrapper>
  )
}
